<template>
  <div class="modal fade show" style="display: block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <h5 class="modal-title">查看保养任务</h5>
          <div class="d-inline-flex justify-content-center align-items-center">
            <div class="dropdown topbar-head-dropdown">
              <button
                type="button"
                class="btn btn-topbar p-0"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  class="fs-18"
                  :class="
                    form.status == 1
                      ? 'ri-checkbox-circle-fill text-success'
                      : 'ri-forbid-fill text-muted'
                  "
                ></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end">
                <span
                  class="
                    dropdown-item
                    notify-item
                    language
                    py-1
                    d-inline-flex
                    align-items-center
                  "
                  style="cursor: pointer"
                  @click="changeStatus(1)"
                >
                  完成
                  <i
                    class="fs-18 ri-checkbox-circle-fill text-success ms-2"
                  ></i>
                </span>
                <span
                  class="
                    dropdown-item
                    notify-item
                    language
                    py-1
                    d-inline-flex
                    align-items-center
                  "
                  style="cursor: pointer"
                  @click="changeStatus(0)"
                >
                  未完成
                  <i class="fs-18 ri-forbid-fill text-muted ms-2"></i>
                </span>
              </div>
            </div>

            <i
              class="fs-18 ri-pencil-fill text-muted me-2 ms-2"
              @click="handleEdit()"
            ></i>

            <i
              class="fs-18 ri-delete-bin-6-fill text-muted"
              v-if="form.cycle == 'nothing'"
              @click="handleDelete(form.id, 'this')"
            ></i>
            <div class="dropdown topbar-head-dropdown" v-else>
              <button
                type="button"
                class="btn btn-topbar p-0"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fs-18 ri-delete-bin-6-fill text-muted"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end">
                <span
                  class="
                    dropdown-item
                    notify-item
                    language
                    py-1
                    d-inline-flex
                    align-items-center
                  "
                  style="cursor: pointer"
                  @click="handleDelete(form.id, 'this')"
                >
                  删除当前
                  <i class="fs-18 ri-delete-bin-6-fill text-danger ms-2"></i>
                </span>
                <span
                  v-if="form.cycle != 'nothing'"
                  class="
                    dropdown-item
                    notify-item
                    language
                    py-1
                    d-inline-flex
                    align-items-center
                  "
                  style="cursor: pointer"
                  @click="handleDelete(form.id, 'features')"
                >
                  删除未来全部
                  <i class="fs-18 ri-delete-bin-6-fill text-danger ms-2"></i>
                </span>
                <span
                  v-if="form.cycle != 'nothing'"
                  class="
                    dropdown-item
                    notify-item
                    language
                    py-1
                    d-inline-flex
                    align-items-center
                  "
                  style="cursor: pointer"
                  @click="handleDelete(form.id, 'all')"
                >
                  删除全部
                  <i class="fs-18 ri-delete-bin-6-fill text-danger ms-2"></i>
                </span>
              </div>
            </div>

            <button
              type="button"
              class="btn-close"
              @click="handleClose"
            ></button>
          </div>
        </div>
        <form>
          <div class="modal-body">
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="name-field" class="form-label">维护保养名称</label>
                <div class="text-muted ms-2 text-wrap text-break">
                  {{ form.maintenance_name }}
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label">设备</label>
                <div class="text-muted ms-2 text-wrap text-break">
                  {{ form.equipment_name }}
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label">维护项目</label>
                <b-list-group>
                  <b-list-group-item
                    v-for="(item, i) in form.items"
                    :key="i"
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      text-muted
                    "
                    >
                    <div class="
                      d-flex
                      align-items-center
                    ">
                      {{ item.name }}
                      <el-tooltip placement="top-start" v-if="filterDescription(item.name)">
                        <template #content>
                          <div style="white-space: pre-wrap;max-width:350px" v-html="filterDescription(item.name)"></div>
                        </template>
                        <i class="ri-information-line text-primary fs-16"></i>
                      </el-tooltip>
                    </div>
                    <i
                      :class="[
                        'fs-20',
                        'ri-checkbox-circle-fill',
                        item.status && 'text-success',
                        !item.status && 'text-muted',
                      ]"
                      @click="handleItemStatus(i)"
                    ></i>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label">维护周期</label>
                <div class="text-muted ms-2">{{ filterCycle(form.cycle) }}</div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-6">
                <label for="start-field" class="form-label">开始时间</label>
                <div class="text-muted ms-2">
                  {{ form.starts && moment(form.starts).format("YYYY-MM-DD") }}
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3" v-show="form.cycle != 'nothing'">
              <div class="col-12">
                <label for="period-field" class="form-label">周期截止至</label>
                <div class="text-muted ms-2">
                  <span class="me-2">{{
                    form.cycletype && filterCycleType(form.cycletype)
                  }}</span>
                  <span v-show="form.cycletype == 2">{{
                    form.ends && moment(form.ends).format("YYYY-MM-DD")
                  }}</span>
                  <span v-show="form.cycletype == 3">{{ form.num }}</span>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="comment-field" class="form-label">资料</label>
                <ul
                  class="list-unstyled mb-0"
                  id="dropzone-preview"
                  v-if="form.attachments"
                >
                  <div
                    class="border rounded"
                    v-for="(file, index) of form.attachments"
                    :key="index"
                  >
                    <div class="d-flex p-2">
                      <div class="flex-grow-1">
                        <div class="pt-1">
                          <h5 class="fs-14 mb-1">
                            <a
                              :href="file.url"
                              :download="file.url"
                              class="text-break"
                            >
                              {{ filterName(file.objectName) }}
                            </a>
                          </h5>
                          <p class="fs-13 text-muted mb-0">
                            <strong>{{ file.size / 1024 }}</strong> KB
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ul>
                <div
                  class="text-center text-muted"
                  v-if="!form.attachments || !form.attachments.length"
                >
                  无数据
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="operator-field" class="form-label">操作人员</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.assignee"
                />
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="comment-field" class="form-label">备注</label>
                <textarea
                  rows="3"
                  class="form-control"
                  v-model="form.summary"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" @click="handleClose">
                取消
              </button>
              <button
                type="button"
                class="btn btn-primary"
                id="add-btn"
                @click="handleSubmit"
              >
                确认
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>
<script>
import _ from "loadsh";
import moment from "moment";
// import DropZone from "@/components/widgets/dropZone";
import { cycleList, cycleTypeList } from "../utils";
import { editMaintenTasks } from "@/service/index.js";
import { ElTooltip} from 'element-plus'
import 'element-plus/theme-chalk/el-tooltip.css'
import 'element-plus/es/components/tooltip/style/css'

export default {
  emits: [
    "update:isShowReportForm",
    "handleAlert",
    "handleEdit",
    "handleDelete",
    "handleGetTasks",
    "changeStatus",
  ],
  props: {
    isShowReportForm: Boolean,
    date: Object,
    singleData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    itemsList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
  components: {
    // DropZone,
    ElTooltip
  },
  watch: {
    singleData: {
      handler(val) {
        this.form = _.cloneDeep(val);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  mounted() {},
  data() {
    return {
      form: {},
    };
  },

  methods: {
    moment,
    filterCycle(cycle) {
      let info = cycleList.find((item) => {
        return item.value === cycle;
      });
      if (info) return info.label;
    },
    filterCycleType(cycletype) {
      let info = cycleTypeList.find((item) => {
        return item.value === cycletype;
      });
      if (info) return info.label;
    },
    filterDescription(name){
      let info = this.itemsList.find((item) => {
        return item.item === name;
      });
      if (info) return info.description;
    },
    handleItemStatus(i) {
      this.form.items[i].status = this.form.items[i].status ? 0 : 1;
    },
    changeStatus(type) {
      let params = {
        status: type,
        starts: this.form.starts,
      };
      let id = this.form.id;
      this.$emit("changeStatus", "report", id, params);
    },
    handleClose() {
      this.$emit("update:isShowReportForm", false);
    },
    handleSubmit() {
      var numtype = {
        nothing: 1,
        da: 1,
        w: 1,
        m: 1,
        y: 1,
        m3: 3,
        m6: 6,
        w1: 1,
        w2: 1,
        w3: 1,
        w4: 1,
        w5: 1,
        w6: 1,
        w7: 1,
      };
      var properties = {
        equipment_name: this.form.equipment_name,
        equipment_id: this.form.equipment_id,
        maintenceItems: this.form.items,
        cycle: this.form.cycle,
        cycletype: this.form.cycletype,
        num: parseInt(this.form.num),
        time: moment().format("HH:mm:ss"),
        status: 0,
        attachments: this.form.attachments,
      };
      var params = {
        title: this.form.maintenance_name,
        repeat: this.form.repeat,
        starts: this.form.starts,
        assignee: this.form.assignee,
        summary: this.form.summary,
        repeat_step: numtype[this.form.cycle],
        properties: JSON.stringify(properties),
      };
      params.mode = "this";
      (params.edit_date = this.form.starts),
        editMaintenTasks(this.form.id, params)
          .then((res) => {
            if (res && _.get(res, ["meta", "code"]) === 0 && res.payload) {
              this.$emit(
                "handleAlert",
                "success",
                "编辑成功!",
                "ri-check-double-line",
                1000
              );
              this.$emit("handleGetTasks", this.date);
              this.handleClose();
            } else {
              this.$emit("handleAlert", "danger", "请求失败, 请重试!");
            }
          })
          .catch((err) => {
            this.$emit(
              "handleAlert",
              "danger",
              err.message || "请求失败, 请重试!"
            );
          });
    },
    handleEdit() {
      this.$emit("update:isShowReportForm", false);
      this.$emit("handleEdit", this.form);
    },
    handleDelete(id, type) {
      this.$emit("handleDelete", id, type);
    },
    filterName(name) {
      if (/^(device\/)/.test(name)) {
        return name.substring(44);
      } else if (/^(reports\/)/.test(name)) {
        return name.substring(45);
      } else if (/^(events\/)/.test(name)) {
        return name.substring(44);
      } else {
        return name;
      }
    },
  },
};
</script>